<template>
  <div class="solutions-container1">
    <app-navigation></app-navigation>
    <section id="hero-section" role="region" aria-labelledby="hero-title" class="hero-solutions">
      <div class="hero-container">
        <div class="hero-content2">
          <h1 id="hero-title" class="hero-title">
            {{ $t('solutions.hero.title') }}
            <span v-html="raweqr7"></span>
          </h1>
          <h2 class="hero-subtitle">{{ $t('solutions.hero.subtitle') }}
            <span v-html="raw03d7"></span>
          </h2>
          <div class="hero-benefits">
            <div class="benefit-item">
              <div class="benefit-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <span>{{ $t('solutions.benefits.designFaster') }}</span>
            </div>
            <div class="benefit-item">
              <div class="benefit-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <span>{{ $t('solutions.benefits.cutErrors') }}</span>
            </div>
            <div class="benefit-item">
              <div class="benefit-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <span>{{ $t('solutions.benefits.shipOnTime') }}</span>
            </div>
          </div>
          <p class="hero-description">
            {{ $t('solutions.benefits.book') }}
            <span v-html="raw7w7s"></span>
          </p>
          <router-link to="/contactdemo">
            <div class="hero-cta-row">
              <button class="btn btn-lg btn-primary" @click="scrollToTop">
                {{ $t('common.scheduleDemo') }}
              </button>
            </div>
          </router-link>
        </div>
        <div class="hero-visual">
          <div class="visual-card">
            <div class="visual-image-wrapper">
              <img alt="CNC machine in action, precisely cutting a wooden panel with sawdust flying." src="https://images.pexels.com/photos/7480234/pexels-photo-7480234.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" loading="eager"/>
              <div class="visual-overlay"></div>
            </div>
            <div role="list" aria-label="Key features" class="badge-row">
              <span role="listitem" class="feature-badge">{{ $t('solutions.intro.oneClickCnc') }}</span>
              <span role="listitem" class="feature-badge">{{ $t('solutions.intro.restApi') }}</span>
              <span role="listitem" class="feature-badge">
                {{ $t('solutions.intro.machinePark') }}
                <span v-html="rawrjsq"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="use-cases-section" role="region" aria-labelledby="use-cases-title" class="use-cases">
      <div class="use-cases-container">
        <h2 id="use-cases-title" class="section-title">
          {{ $t('solutions.intro.solutionsTitle') }}
          <span v-html="rawk4go"></span>
        </h2>
        <div class="use-cases-grid">
          <article class="use-case-card">
            <div class="card-header">
              <h3 class="card-title">{{ $t('solutions.solutions.smallShops.title') }}</h3>
              <span class="card-badge">{{ $t('solutions.solutions.smallShops.subtitle') }}</span>
            </div>
            <div class="card-body">
              <ol class="timeline-list">
                <li class="timeline-step1">
                  <div class="step-marker"><span>1</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.smallShops.steps.design.title') }}</h4>
                    <p>{{ $t('solutions.solutions.smallShops.steps.design.description') }}</p>
                  </div>
                </li>
                <li class="timeline-step1">
                  <div class="step-marker"><span>2</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.smallShops.steps.output.title') }}</h4>
                    <p>{{ $t('solutions.solutions.smallShops.steps.output.description') }}</p>
                  </div>
                </li>
                <li class="timeline-step1">
                  <div class="step-marker"><span>3</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.smallShops.steps.nesting.title') }}</h4>
                    <p>{{ $t('solutions.solutions.smallShops.steps.nesting.description') }}</p>
                  </div>
                </li>
                <li class="timeline-step1">
                  <div class="step-marker"><span>4</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.smallShops.steps.labeling.title') }}</h4>
                    <p>{{ $t('solutions.solutions.smallShops.steps.labeling.description') }}</p>
                  </div>
                </li>
              </ol>
            </div>
            <div class="card-footer">
              <div class="roi-snapshot">
                <div class="roi-stat">
                  <span class="stat-value">40-60%</span>
                  <span class="stat-label1">{{ $t('solutions.solutions.smallShops.stats.title') }}</span>
                </div>
              </div>
            </div>
          </article>
          <article class="use-case-card featured-card">
            <div class="card-header">
              <h3 class="card-title">{{ $t('solutions.solutions.growingTeams.title') }}</h3>
              <span class="card-badge card-badge-primary">{{ $t('solutions.solutions.growingTeams.subtitle') }}</span>
            </div>
            <div class="card-body">
              <ol class="timeline-list">
                <li class="timeline-step1">
                  <div class="step-marker"><span>1</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.growingTeams.steps.centrale.title') }}</h4>
                    <p>{{ $t('solutions.solutions.growingTeams.steps.centrale.description') }}</p>
                  </div>
                </li>
                <li class="timeline-step1">
                  <div class="step-marker"><span>2</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.growingTeams.steps.auto.title') }}</h4>
                    <p>{{ $t('solutions.solutions.growingTeams.steps.auto.description') }}</p>
                  </div>
                </li>
                <li class="timeline-step1">
                  <div class="step-marker"><span>3</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.growingTeams.steps.batch.title') }}</h4>
                    <p>{{ $t('solutions.solutions.growingTeams.steps.batch.description') }}</p>
                  </div>
                </li>
                <li class="timeline-step1">
                  <div class="step-marker"><span>4</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.growingTeams.steps.easy.title') }}</h4>
                    <p>{{ $t('solutions.solutions.growingTeams.steps.easy.description') }}</p>
                  </div>
                </li>
              </ol>
            </div>
            <div class="card-footer">
              <div class="roi-snapshot">
                <div class="roi-stat">
                  <span class="stat-value">50%</span>
                  <span class="stat-label1">{{ $t('solutions.solutions.growingTeams.stats.title') }}</span>
                </div>
              </div>
            </div>
          </article>
          <article class="use-case-card">
            <div class="card-header">
              <h3 class="card-title">{{ $t('solutions.solutions.factories.title') }}</h3>
              <span class="card-badge">{{ $t('solutions.solutions.factories.subtitle') }}</span>
            </div>
            <div class="card-body">
              <ol class="timeline-list">
                <li class="timeline-step1">
                  <div class="step-marker"><span>1</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.factories.steps.high.title') }}</h4>
                    <p>{{ $t('solutions.solutions.factories.steps.high.description') }}</p>
                  </div>
                </li>
                <li class="timeline-step1">
                  <div class="step-marker"><span>2</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.factories.steps.multi.title') }}</h4>
                    <p>{{ $t('solutions.solutions.factories.steps.multi.description') }}</p>
                  </div>
                </li>
                <li class="timeline-step1">
                  <div class="step-marker"><span>3</span></div>
                  <div class="step-content">
                    <h4 class="step-title">{{ $t('solutions.solutions.factories.steps.erp.title') }}</h4>
                    <p>{{ $t('solutions.solutions.factories.steps.erp.description') }}</p>
                  </div>
                </li>
              </ol>
            </div>
            <div class="card-footer">
              <div class="roi-snapshot">
                <div class="roi-stat">
                  <span class="stat-value">20-35%</span>
                  <span class="stat-label1">{{ $t('solutions.solutions.factories.stats.title') }}</span>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
    <section id="roi-section" role="region" aria-labelledby="roi-title" class="roi-impact">
      <div class="roi-container">
        <h2 id="roi-title" class="section-title">
          {{ $t('solutions.roi.title') }}
          <span v-html="rawq7rh"></span>
        </h2>
        <div class="roi-grid">
          <div class="roi-featured-card">
            <h3>{{ $t('solutions.roi.featuredCard.title') }}</h3>
            <p>{{ $t('solutions.roi.featuredCard.description') }}
              <span v-html="rawnoiz"></span>
            </p>
          </div>
          <div class="roi-metrics1">
            <div class="metric-card">
              <div class="metric-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div class="metric-content">
                <h4 class="metric-value1">40-60%</h4>
                <p class="metric-label1">{{ $t('solutions.roi.metrics.timePerJobSmallShops.label') }}</p>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle r="4" cx="9" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <div class="metric-content">
                <h4 class="metric-value1">90%</h4>
                <p class="metric-label1">
                  {{ $t('solutions.roi.metrics.handoffMistakesGrowingTeams.label') }}
                </p>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <div class="metric-content">
                <h4 class="metric-value1">2-3x</h4>
                <p class="metric-label1">
                  {{ $t('solutions.roi.metrics.batchProcessingLargerFactories.label') }}
                  <span v-html="rawgpq0"></span>
                </p>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-icon">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M16 7h6v6"></path>
                    <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                  </g>
                </svg>
              </div>
              <div class="metric-content">
                <h4 class="metric-value1">30%</h4>
                <p class="metric-label1">{{ $t('solutions.roi.metrics.machineUtilisation.label') }}</p>
              </div>
            </div>
          </div>
          <div class="roi-proof-card">
            <h3>{{ $t('solutions.roi.proofCard.title') }}</h3>
            <ul class="proof-list">
              <li>
                <span>{{ $t('solutions.roi.proofCard.items.oneperson') }}
                  <span v-html="rawtksz"></span>
                </span>
              </li>
              <li>
                <span>{{ $t('solutions.roi.proofCard.items.midsize') }}
                  <span v-html="raw79u9"></span>
                </span>
              </li>
              <li>
                <span>{{ $t('solutions.roi.proofCard.items.factory') }}
                  <span v-html="rawjz7h"></span>
                </span>
              </li>
            </ul>
            <div class="proof-badges">
              <span class="proof-badge">{{ $t('common.oneClick') }}</span>
              <span class="proof-badge">{{ $t('common.restApi') }}</span>
              <span class="proof-badge">{{ $t('common.machinePark') }}</span>
            </div>
          </div>
          <div class="roi-cta-card">
            <h3>{{ $t('solutions.roi.ctaCard.title') }}</h3>
            <p>{{ $t('solutions.roi.ctaCard.description') }}
              <span v-html="rawv7jy"></span>
            </p>
            <div class="roi-estimate-steps">
              <div class="estimate-step">
                <span class="estimate-number">1</span>
                <span class="estimate-text">{{ $t('solutions.roi.ctaCard.steps.shareWorkflow') }}</span>
              </div>
              <div class="estimate-step">
                <span class="estimate-number">2</span>
                <span class="estimate-text">{{ $t('solutions.roi.ctaCard.steps.getRoiEstimate') }}</span>
              </div>
              <div class="estimate-step">
                <span class="estimate-number">3</span>
                <span class="estimate-text">{{ $t('solutions.roi.ctaCard.steps.testWithYourData') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="integrations-section" role="region" aria-labelledby="integrations-title" class="integrations-snapshot">
      <div class="integrations-container">
        <h2 id="integrations-title" class="section-title">
          {{ $t('solutions.integrations.title') }}
          <span v-html="rawf7g1"></span>
        </h2>
        <div class="integrations-layout">
          <div class="integrations-steps">
            <article class="integration-step-card">
              <div class="step-header">
                <div class="step-number1"><span>1</span></div>
                <h3 class="step-title">{{ $t('solutions.integrations.steps.smallShops.title') }}</h3>
              </div>
              <div class="step-body">
                <ul class="integration-highlights">
                  <li><span>{{ $t('solutions.integrations.steps.smallShops.highlights.hl1') }}</span></li>
                  <li><span>{{ $t('solutions.integrations.steps.smallShops.highlights.hl2') }}</span></li>
                  <li><span>{{ $t('solutions.integrations.steps.smallShops.highlights.hl3') }}</span></li>
                </ul>
                <div class="workflow-flow">
                  <span class="flow-item">{{ $t('solutions.integrations.steps.smallShops.flow.design') }}</span>
                  <span class="flow-arrow">→</span>
                  <span class="flow-item">{{ $t('solutions.integrations.steps.smallShops.flow.autoNest') }}</span>
                  <span class="flow-arrow">→</span>
                  <span class="flow-item">{{ $t('solutions.integrations.steps.smallShops.flow.sendGcode') }}</span>
                  <span class="flow-arrow">→</span>
                  <span class="flow-item">{{ $t('solutions.integrations.steps.smallShops.flow.printLabels') }}</span>
                </div>
                <p class="step-ideal">
                  {{ $t('solutions.integrations.steps.smallShops.ideal') }}
                  <span v-html="raw3vkl"></span>
                </p>
              </div>
            </article>
            <article class="integration-step-card">
              <div class="step-header">
                <div class="step-number1"><span>2</span></div>
                <h3 class="step-title">{{ $t('solutions.integrations.steps.growingTeams.title') }}</h3>
              </div>
              <div class="step-body">
                <ul class="integration-highlights">
                  <li><span>{{ $t('solutions.integrations.steps.growingTeams.highlights.hl1') }}</span></li>
                  <li><span>{{ $t('solutions.integrations.steps.growingTeams.highlights.hl2') }}</span></li>
                  <li><span>{{ $t('solutions.integrations.steps.growingTeams.highlights.hl3') }}</span></li>
                </ul>
                <div class="workflow-flow">
                  <span class="flow-item">{{ $t('solutions.integrations.steps.growingTeams.flow.parametricKits') }}</span>
                  <span class="flow-arrow">→</span>
                  <span class="flow-item">{{ $t('solutions.integrations.steps.growingTeams.flow.batchJobs') }}</span>
                  <span class="flow-arrow">→</span>
                  <span class="flow-item">{{ $t('solutions.integrations.steps.growingTeams.flow.shopfloorDispatch') }}</span>
                </div>
                <p class="step-ideal">
                  {{ $t('solutions.integrations.steps.growingTeams.ideal') }}
                  <span v-html="rawucsi"></span>
                </p>
              </div>
            </article>
            <article class="integration-step-card">
              <div class="step-header">
                <div class="step-number1"><span>3</span></div>
                <h3 class="step-title">
                  {{ $t('solutions.integrations.steps.largerFactories.title') }}
                  <span v-html="rawk3u5"></span>
                </h3>
              </div>
              <div class="step-body">
                <ul class="integration-highlights">
                  <li><span>{{ $t('solutions.integrations.steps.largerFactories.highlights.hl1') }}</span></li>
                  <li><span>{{ $t('solutions.integrations.steps.largerFactories.highlights.hl2') }}</span></li>
                  <li><span>{{ $t('solutions.integrations.steps.largerFactories.highlights.hl3') }}</span></li>
                </ul>
                <div class="workflow-flow">
                  <span class="flow-item">{{ $t('solutions.integrations.steps.largerFactories.flow.configurator') }}</span>
                  <span class="flow-arrow">→</span>
                  <span class="flow-item">{{ $t('solutions.integrations.steps.largerFactories.flow.crashChecks') }}</span>
                  <span class="flow-arrow">→</span>
                  <span class="flow-item">{{ $t('solutions.integrations.steps.largerFactories.flow.nesting') }}</span>
                  <span class="flow-arrow">→</span>
                  <span class="flow-item">{{ $t('solutions.integrations.steps.largerFactories.flow.traceableLabels') }}</span>
                </div>
                <p class="step-ideal">
                  {{ $t('solutions.integrations.steps.largerFactories.ideal') }}
                  <span v-html="rawwo6l"></span>
                </p>
              </div>
            </article>
          </div>
          <aside class="integrations-sidebar">
            <div class="sidebar-card">
              <h4>{{ $t('solutions.integrations.sidebar.commonConnectors.title') }}</h4>
              <div class="connector-grid">
                <div class="connector-item">
                  <div class="connector-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <span>{{ $t('solutions.integrations.sidebar.commonConnectors.items.it1') }}</span>
                </div>
                <div class="connector-item">
                  <div class="connector-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                        <path d="m3.3 7l8.7 5l8.7-5M12 22V12"></path>
                      </g>
                    </svg>
                  </div>
                  <span>{{ $t('solutions.integrations.sidebar.commonConnectors.items.it2') }}</span>
                </div>
                <div class="connector-item">
                  <div class="connector-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                        <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                        <path d="M3 12a9 3 0 0 0 18 0"></path>
                      </g>
                    </svg>
                  </div>
                  <span>{{ $t('solutions.integrations.sidebar.commonConnectors.items.it3') }}</span>
                </div>
                <div class="connector-item">
                  <div class="connector-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                      </g>
                    </svg>
                  </div>
                  <span>{{ $t('solutions.integrations.sidebar.commonConnectors.items.it4') }}</span>
                </div>
                <div class="connector-item">
                  <div class="connector-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                        <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                        <path d="M3 12a9 3 0 0 0 18 0"></path>
                      </g>
                    </svg>
                  </div>
                  <span>{{ $t('solutions.integrations.sidebar.commonConnectors.items.it5') }}</span>
                </div>
                <div class="connector-item">
                  <div class="connector-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                      </g>
                    </svg>
                  </div>
                  <span>{{ $t('solutions.integrations.sidebar.commonConnectors.items.it6') }}</span>
                </div>
              </div>
            </div>
            <div class="sidebar-card">
              <h4>{{ $t('solutions.integrations.sidebar.quickStartChecklist.title') }}</h4>
              <div class="checklist">
                <div class="checklist-section">
                  <h5>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.smallShops.title') }}</h5>
                  <ul>
                    <li><span>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.smallShops.items.it1') }}</span></li>
                    <li><span>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.smallShops.items.it2') }}</span></li>
                  </ul>
                </div>
                <div class="checklist-section">
                  <h5>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.growingTeams.title') }}</h5>
                  <ul>
                    <li><span>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.growingTeams.items.it1') }}</span></li>
                    <li><span>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.growingTeams.items.it2') }}</span></li>
                    <li><span>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.growingTeams.items.it3') }}</span></li>
                  </ul>
                </div>
                <div class="checklist-section">
                  <h5>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.factories.title') }}</h5>
                  <ul>
                    <li><span>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.factories.items.it1') }}</span></li>
                    <li><span>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.factories.items.it2') }}</span></li>
                    <li><span>{{ $t('solutions.integrations.sidebar.quickStartChecklist.sections.factories.items.it3') }}</span></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="sidebar-badges">
              <span class="sidebar-badge">{{ $t('common.oneClick') }}</span>
              <span class="sidebar-badge">{{ $t('common.restApi') }}</span>
              <span class="sidebar-badge">{{ $t('common.machinePark') }}</span>
            </div>
          </aside>
        </div>
      </div>
    </section>
    <section id="demo-section" role="region" aria-labelledby="demo-title" class="demo-cta">
      <div class="demo-container">
        <div class="demo-content">
          <h2 id="demo-title" class="section-title">{{ $t('solutions.integrations.schedule.title') }}</h2>
          <p class="demo-intro">{{ $t('solutions.integrations.schedule.subtitle') }}
            <span v-html="rawigu6"></span>
          </p>
          <div class="demo-benefits">
            <h3>{{ $t('solutions.integrations.schedule.whybook') }}</h3>
            <ul class="benefit-list">
              <li>
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('solutions.integrations.schedule.live') }}</span>
              </li>
              <li>
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('solutions.integrations.schedule.real') }}</span>
              </li>
              <li>
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('solutions.integrations.schedule.clear') }}</span>
              </li>
            </ul>
          </div>
          <div class="demo-badges-row">
            <span class="demo-badge">{{ $t('common.oneClick') }}</span>
            <span class="demo-badge">{{ $t('common.restApi') }}</span>
            <span class="demo-badge">{{ $t('common.machinePark') }}</span>
          </div>
          <router-link to="/contactdemo">
            <div class="hero-cta-row">
              <button class="btn btn-lg btn-primary" @click="scrollToTop">
                {{ $t('common.scheduleDemo') }}
              </button>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head'

import AppNavigation from '../components/navigation'
import AppFooter from '../components/footer'

export default {
  name: 'Solutions',
  props: {},
  components: {
    AppNavigation,
    AppFooter,
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: 'Solutions - KORPUS by VLECAD®',
      meta: [
        {
          name: 'description',
          content:
            'KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.',
        },
        {
          property: 'og:title',
          content: 'Solutions - KORPUS by VLECAD®',
        },
        {
          property: 'og:description',
          content:
            'KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.',
        },
        {
          property: 'og:image',
          content:
            'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://hospitable-imperfect-heron-qlicxu.teleporthq.app/solutions',
        },
      ],
    })
  },
  data() {
    return {
      raweqr7: ' ',
      raw03d7: ' ',
      raw7w7s: ' ',
      rawrjsq: ' ',
      rawk4go: ' ',
      rawq7rh: ' ',
      rawnoiz: ' ',
      rawgpq0: ' ',
      rawtksz: ' ',
      raw79u9: ' ',
      rawjz7h: ' ',
      rawv7jy: ' ',
      rawf7g1: ' ',
      rawat0p: ' ',
      raw3vkl: ' ',
      rawucsi: ' ',
      rawk3u5: ' ',
      rawwo6l: ' ',
      rawigu6: ' ',
      rawawc7: ' ',
      rawyxbk: ' ',
      rawk8gx: ' ',
      rawkobv: ' ',
      rawq0fm: ' ',
      rawtwnk: ' ',
      rawohsx: ' ',
      rawhqnp: ' ',
      raw7srx: ' ',
      raw36ra: ' ',
      raw5bo6: ' ',
      rawxvdt: ' ',
      raw1gff: ' ',
      raw85rv: ' ',
      rawfxw7: ' ',
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
}
</script>

<style>
@keyframes heroFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes cardFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .hero-container {
    animation: none;
    opacity: 1;
    transform: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .use-case-card {
    animation: none;
    opacity: 1;
    transform: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .faq-icon,
  .faq-panel {
    transition: none;
  }
  .faq-header[aria-expanded='true'] .faq-icon {
    transform: none;
  }
}
* {
  transition: background-color var(--animation-duration-fast)
      var(--animation-curve-primary),
    color var(--animation-duration-fast) var(--animation-curve-primary),
    border-color var(--animation-duration-fast) var(--animation-curve-primary);
}
</style>

<style scoped>
.solutions-container1 {
  width: 100%;
  display: block;
  min-height: 100vh;
}
 
.solutions-container2 {
  display: none;
}
 
.solutions-container3 {
  display: contents;
}
 
.solutions-container4 {
  display: none;
}
 
.solutions-container5 {
  display: contents;
}
 
.solutions-container6 {
  display: none;
}
 
.solutions-container7 {
  display: contents;
}
 
.solutions-thq-hero-secondary-link-elm {
  display: none;
}
 
.solutions-thq-timeline-step-elm21 {
  display: none;
}
 
.solutions-thq-demo-secondary-link-elm {
  display: none;
}
 
.solutions-thq-btn-elm20 {
  width: 100%;
}
 
.solutions-thq-form-secondary-link-elm {
  display: none;
}
 
.solutions-thq-customer-outcomes-elm {
  display: none;
}
 
.solutions-thq-speaker-info-elm1 {
  gap: var(--spacing-xs);
  display: flex;
  flex-direction: column;
}
 
.solutions-thq-outcome-stats-elm1 {
  gap: var(--spacing-sm);
  display: flex;
}
 
.solutions-thq-speaker-info-elm2 {
  gap: var(--spacing-xs);
  display: flex;
  flex-direction: column;
}
 
.solutions-thq-outcome-stats-elm2 {
  gap: var(--spacing-sm);
  display: flex;
}
 
.solutions-thq-speaker-info-elm3 {
  gap: var(--spacing-xs);
  display: flex;
  flex-direction: column;
}
 
.solutions-thq-outcome-stats-elm3 {
  gap: var(--spacing-sm);
  display: flex;
}
 
.solutions-thq-faq-elm {
  display: none;
}
 
.solutions-thq-faq-question-elm1 {
  color: var(--color-on-surface);
  margin: 0;
  font-size: var(--font-size-lg);
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}
 
.solutions-thq-faq-icon-elm1 {
  color: var(--color-on-surface-secondary);
  width: 24px;
  height: 24px;
  transition: transform var(--animation-duration-fast)
      var(--animation-curve-primary);
  flex-shrink: 0;
}
 
.solutions-thq-faq-question-elm2 {
  color: var(--color-on-surface);
  margin: 0;
  font-size: var(--font-size-lg);
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}
 
.solutions-thq-faq-icon-elm2 {
  color: var(--color-on-surface-secondary);
  width: 24px;
  height: 24px;
  transition: transform var(--animation-duration-fast)
      var(--animation-curve-primary);
  flex-shrink: 0;
}
 
.solutions-thq-faq-question-elm3 {
  color: var(--color-on-surface);
  margin: 0;
  font-size: var(--font-size-lg);
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}
 
.solutions-thq-faq-icon-elm3 {
  color: var(--color-on-surface-secondary);
  width: 24px;
  height: 24px;
  transition: transform var(--animation-duration-fast)
      var(--animation-curve-primary);
  flex-shrink: 0;
}
 
.solutions-thq-faq-question-elm4 {
  color: var(--color-on-surface);
  margin: 0;
  font-size: var(--font-size-lg);
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}
 
.solutions-thq-faq-icon-elm4 {
  color: var(--color-on-surface-secondary);
  width: 24px;
  height: 24px;
  transition: transform var(--animation-duration-fast)
      var(--animation-curve-primary);
  flex-shrink: 0;
}
 
.solutions-thq-faq-question-elm5 {
  color: var(--color-on-surface);
  margin: 0;
  font-size: var(--font-size-lg);
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}
 
.solutions-thq-faq-icon-elm5 {
  color: var(--color-on-surface-secondary);
  width: 24px;
  height: 24px;
  transition: transform var(--animation-duration-fast)
      var(--animation-curve-primary);
  flex-shrink: 0;
}
 
.solutions-thq-faq-question-elm6 {
  color: var(--color-on-surface);
  margin: 0;
  font-size: var(--font-size-lg);
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}
 
.solutions-thq-faq-icon-elm6 {
  color: var(--color-on-surface-secondary);
  width: 24px;
  height: 24px;
  transition: transform var(--animation-duration-fast)
      var(--animation-curve-primary);
  flex-shrink: 0;
}
 
.solutions-thq-faq-sidebar-elm {
  display: none;
}
 
.solutions-thq-btn-elm30 {
  width: 100%;
}
 
@media(max-width: 767px) {
  .solutions-thq-faq-question-elm1 {
    font-size: var(--font-size-md);
  }
  .solutions-thq-faq-question-elm2 {
    font-size: var(--font-size-md);
  }
  .solutions-thq-faq-question-elm3 {
    font-size: var(--font-size-md);
  }
  .solutions-thq-faq-question-elm4 {
    font-size: var(--font-size-md);
  }
  .solutions-thq-faq-question-elm5 {
    font-size: var(--font-size-md);
  }
  .solutions-thq-faq-question-elm6 {
    font-size: var(--font-size-md);
  }
}
</style>
